(() => {
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('show');
    drawer.style.display = 'block';
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const backdrop = document.createElement('div');
    backdrop.className = 'drawer-backdrop fade show';
    backdrop.addEventListener('click', () => closeDrawer(drawer));
    drawer.dataset.backdropId = 'drawer-backdrop';
    document.body.appendChild(backdrop);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('show');
    drawer.style.display = '';
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    const backdrop = document.querySelector('.drawer-backdrop');
    if (backdrop) backdrop.remove();
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-toggle="drawer"]');
    if (toggle) {
      event.preventDefault();
      const targetSelector = toggle.getAttribute('data-target');
      const drawer = document.querySelector(targetSelector);
      openDrawer(drawer);
      return;
    }

    const dismiss = event.target.closest('[data-dismiss="drawer"]');
    if (dismiss) {
      event.preventDefault();
      const drawer = dismiss.closest('.drawer');
      closeDrawer(drawer);
    }
  });
})();
